export const REALITY_CHECK = {
  title: "About Onnii",
  subtitle: "The good, the great, the slightly ridiculous",
  body:
    "Saloni is the kind of woman who remembers everyone's coffee order, notices when someone's off in the group chat, and quietly makes sure the family actually shows up for each other. She's Perk's calm, Via's whole universe, and Pista's favourite person to annoy in the world. Woh apni family ka anchor hai — steady, fierce, and unreasonably good at knowing exactly what to say. Bahut solid wife, badiya maa, aur ekdum precious dost.\n\nAlso — she reheats one cup of coffee till 2:47 PM every single day, owns 40% of her closet in shades of blue, hates mithai like it personally offended her ancestors, and can spot a Crumbl flavour drop from 3 rooms away. Full-time legend, part-time menace. Bilkul Bob.",
  tags: [
    "Anchor of the group chat",
    "Softy loyalist",
    "Pani puri diplomat",
    "Certified doom-scroller",
    "Blue dress collector",
    "Mithai-refuser",
  ],
};

export const SOFT_SIDE = {
  title: "The Soft Side",
  subtitle: "The parts we don't roast (much)",
  body:
    "The reached-safely texts before you've even walked to your car. The 3 AM 'kya hua, sab theek?' voice notes. The way she remembers your one weird food allergy and always keeps something in the fridge for you. Woh apne logo ke liye poori tarah se present rehti hai — quietly, completely, without ever making it a big deal. The world got softer when Bob walked into it.",
};

export const MOM_MODE = {
  title: "Mom Mode",
  subtitle: "Ft. Via, 1 year 9 months, CEO",
  body:
    "One minute she's slaying board meetings and organising the entire family in one WhatsApp message. Next minute she's chasing Via around with a spoon of dal, hair in a bun, singing 'aeroplane aeroplane' with Broadway-level commitment. Motherhood didn't dim her — usne aur bhi chamka diya. Slightly more chaotic. Definitely more caffeinated. And still — occasionally — sharing her softy with Via. But only with Via.",
};
